import type { ExtractionEntity } from '../../stores/acombaBridgeStore';
import { TranslationKey } from '../../i18n/translationKeys';

const ENTITY_LABEL_KEY: Record<ExtractionEntity, string> = {
    customers: TranslationKey.AcombaBridge.Extraction.Customers,
    invoices: TranslationKey.AcombaBridge.Extraction.Invoices,
    payments: TranslationKey.AcombaBridge.Extraction.Payments,
};

/**
 * Builds the error-toast message shown when a sync is aborted because one or more Acomba interfaces
 * failed to read. Names the failed interfaces so the user knows what went wrong. `t` is passed in so
 * translation stays in the React layer.
 */
export function extractionIncompleteMessage(
    failed: ExtractionEntity[],
    t: (key: string, options?: Record<string, unknown>) => string,
): string {
    const interfaces = failed.map((e) => t(ENTITY_LABEL_KEY[e])).join(', ');
    return t(TranslationKey.AcombaBridge.Errors.SyncIncomplete, { interfaces });
}
